import React, { useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'

import { ColDef } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'

import { Separator } from '@core/separator'

import AgGrid from '@components/ag-grid'
import { useFetchScheduleHistory } from '@components/control-panel/report-scheduler/queries/notification-profiles/fetch-schedule-history'

import { timeZoneDateColumnDef } from '@layout-components/general/data-connections/utils/col-defs'

import { selectCurrentPage } from '@store/slices/navigation'
import { selectUserBusinessTimeZone } from '@store/slices/user-preferences'

const ScheduleHistory = () => {
  const currentPage = useSelector(selectCurrentPage)
  const { isPending, data } = useFetchScheduleHistory(currentPage?.pageSettings?.id)
  const timeZone = useSelector(selectUserBusinessTimeZone)

  const gridRef = useRef<AgGridReact>(null)

  const columnDefs: ColDef[] = useMemo(() => {
    return [timeZoneDateColumnDef('alertTime', 'Sent at', timeZone)]
  }, [timeZone])

  const parsedData = useMemo(() => {
    return data?.reduce((acc, curr) => {
      acc.push({
        ...curr,
        path: `${curr.id}`
      })
      if (curr?.notifications.length > 0) {
        acc.push(
          ...curr.notifications.map((notification) => ({
            ...notification,
            path: `${notification.alertId}.${notification.id}`,
            alertTime: notification.sentAt
          }))
        )
      }
      return acc
    }, [] as any[])
  }, [data])

  return (
    <>
      <div className='flex h-full flex-col gap-2'>
        <div className='flex min-h-0 grow flex-col'>
          <Separator className='w-full' />
          <div className='min-h-0 grow'>
            <AgGrid
              style={{ height: 'calc(100% - 10%)' }}
              ref={gridRef}
              autoSizeStrategy={{ type: 'fitGridWidth' }}
              rowData={parsedData}
              columnDefs={columnDefs}
              groupDefaultExpanded={0}
              treeData={true}
              getDataPath={(row) => row.path.split('.')}
              autoGroupColumnDef={{
                headerName: 'Alert',
                minWidth: 280,
                valueFormatter: (params) => {
                  if (params.data.email) {
                    return params.data.email
                  }
                  return params.data.id
                },
                cellRendererParams: {
                  suppressCount: true
                }
              }}
              defaultColDef={{
                resizable: true,
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: {
                  buttons: ['clear']
                }
              }}
              loading={isPending}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ScheduleHistory
